PJQ.views.settings.PayableInvoiceSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'payable-invoices'),
        model: null,
        customFields: null
    },
    events: {},
    beforeFirstRender: function () {
        this.listenTo(this.model, 'fetch', this.render);
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: _.bind(this.onChange, this)
        });

        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format'),
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('numberFormat', value);
                this.onChange();
            }
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-line-item-order-by'),
            defaultValue: this.model.get('lineItemOrderBy'),
            onChange: _.bind(function (value) {
                this.model.set('lineItemOrderBy', value);
                this.onChange();
            }, this)
        });
    },
    onChange: function () {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.model);
        }
    }
});

PJQ.views.settings.ReceivableInvoiceSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'receivable-invoices'),
        model: null,
        customFields: null
    },
    events: {},
    beforeFirstRender: function () {
        this.listenTo(this.model, 'fetch', this.render);
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: _.bind(this.onChange, this)
        });

        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format'),
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('numberFormat', value);
                this.onChange();
            }
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-line-item-order-by'),
            defaultValue: this.model.get('lineItemOrderBy'),
            onChange: _.bind(function (value) {
                this.model.set('lineItemOrderBy', value);
                this.onChange();
            }, this)
        });
    },
    onChange: function () {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.model);
        }
    }
});